/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';

/** ReadCandidatesReputationDetailsRequest — dark-roast DTO: ReputationDetailsSearchRequestDto; also used by readOpportunitiesReputationDetails, readUsersReputationDetails */
export const readCandidatesReputationDetailsRequestSchema = z.object({ "order": z.enum(["asc", "desc"]), "page": z.number(), "pageSize": z.number(), "search": z.string().nullish(), "sort": z.string() });
export type ReadCandidatesReputationDetailsRequest = z.infer<typeof readCandidatesReputationDetailsRequestSchema>;
